"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dialing_code_to_country_code_1 = __importDefault(require("./data/dialing-code-to-country-code"));
var DecoratedNumber = /** @class */ (function () {
    function DecoratedNumber(parts) {
        this.parts = parts;
    }
    DecoratedNumber.prototype.serializeTo = function (format, filter) {
        return this.parts.filter(filter).map(function (p) { return p.text(format); }).join("");
    };
    Object.defineProperty(DecoratedNumber.prototype, "international", {
        get: function () {
            return this.serializeTo("international" /* International */, function (p) { return p.international; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecoratedNumber.prototype, "local", {
        get: function () {
            return this.serializeTo("local" /* Local */, function (p) { return p.local; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecoratedNumber.prototype, "e164", {
        get: function () {
            return this.serializeTo("e164" /* E164 */, function (p) { return p.e164; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecoratedNumber.prototype, "dialingCode", {
        get: function () {
            return this.serializeTo("dialingCode" /* DialingCode */, function (p) { return p.dialingCode; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecoratedNumber.prototype, "areaCode", {
        get: function () {
            return this.serializeTo("areaCode" /* AreaCode */, function (p) { return p.areaCode; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecoratedNumber.prototype, "countryCode", {
        get: function () {
            return dialing_code_to_country_code_1.default["" + this.dialingCode + this.areaCode] ||
                dialing_code_to_country_code_1.default[this.dialingCode];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DecoratedNumber.prototype, "extension", {
        get: function () {
            return this.serializeTo("extension" /* Extension */, function (p) { return p.extension && !p.decorative; });
        },
        enumerable: true,
        configurable: true
    });
    return DecoratedNumber;
}());
exports.default = DecoratedNumber;
//# sourceMappingURL=decorated-number.js.map